/* app/js/src/components/common/ag-grid-evrideo/ag-grid-evrideo-select-all-header-column/ag-grid-evrideo-select-all-header-column.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  margin: 0 -19px;
}
svg {
  position: relative;
  top: 6px;
  left: -10px;
}
svg.upside-down {
  transform: rotate(180deg);
}
/*# sourceMappingURL=ag-grid-evrideo-select-all-header-column.component.css.map */
